import { render, staticRenderFns } from "./CentificationDialog.vue?vue&type=template&id=2e0ffd3c&scoped=true&"
import script from "./CentificationDialog.vue?vue&type=script&lang=js&"
export * from "./CentificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CentificationDialog.vue?vue&type=style&index=0&id=2e0ffd3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ffd3c",
  null
  
)

export default component.exports